export default function isValidVatNumber (input) {
  return String(input).match(/(NL)?[0-9]{9}B[0-9]{2}/gm) !== null
}
